// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license Copyright (c) 2003-2018, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

.ck-content code {
    background-color: hsla(0, 0%, 78%, 0.3);
    padding: 0.35em !important;
    border-radius: 4px !important;
  }

.ck-code-block {
    background: #232351 !important;
    color: #ffffff;
    padding: 0.5rem 1rem !important;
    display: inline-block;
    font-size: 13px;
    border-radius: 4px !important;
    white-space: pre-wrap;
  }
`, "",{"version":3,"sources":["webpack://./app/components/TextEditor/Plugins/CodeBlock/theme/codeBlock.module.scss"],"names":[],"mappings":"AAAA;;;EAGE;;AAGA;IACE,uCAAuC;IACvC,0BAA0B;IAC1B,6BAA6B;EAC/B;;AAEA;IACE,8BAA8B;IAC9B,cAAc;IACd,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,6BAA6B;IAC7B,qBAAqB;EACvB","sourcesContent":["/**\n * @license Copyright (c) 2003-2018, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md.\n */\n\n:global {\n  .ck-content code {\n    background-color: hsla(0, 0%, 78%, 0.3);\n    padding: 0.35em !important;\n    border-radius: 4px !important;\n  }\n\n  .ck-code-block {\n    background: #232351 !important;\n    color: #ffffff;\n    padding: 0.5rem 1rem !important;\n    display: inline-block;\n    font-size: 13px;\n    border-radius: 4px !important;\n    white-space: pre-wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
